// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * NOTE: the copious use of \`important\` is needed to overwrite
 * the default tooltip styling, and is required by the 3rd party
 * library being used, \`react-tooltip\`
 */

/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.coming-soon_coming-soon_tt9Ea {
  background-color: var(--data-primary) !important;
  border: 1px solid var(--ui-black-transparent) !important;
  border-radius: calc(0.5rem / 2) !important;
  box-shadow: 0 0 0.5rem var(--ui-black-transparent) !important;
  padding: 0.75rem 1rem !important;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
  font-size: 1rem !important;
  line-height: 1.25rem !important;
  z-index: 47 !important;
}

.coming-soon_coming-soon_tt9Ea:after {
  content: '';
  border-top: 1px solid var(--ui-black-transparent) !important;
  border-left: 0 !important;
  border-bottom: 0 !important;
  border-right: 1px solid var(--ui-black-transparent) !important;
  border-radius: calc(0.5rem / 2);
  background-color: var(--data-primary) !important;
  height: 1rem !important;
  width: 1rem !important;
}

.coming-soon_show_sVGRX,
.coming-soon_show_sVGRX:before,
.coming-soon_show_sVGRX:after {
  opacity: 1 !important;
}

.coming-soon_left_t3Kyn:after {
  margin-top: -0.5rem !important;
  right: -0.5rem !important;
  transform: rotate(45deg) !important;
}

.coming-soon_right_nM46w:after {
  margin-top: -0.5rem !important;
  left: -0.5rem !important;
  transform: rotate(-135deg) !important;
}

.coming-soon_top_tnTlL:after {
  margin-right: -0.5rem !important;
  bottom: -0.5rem !important;
  transform: rotate(135deg) !important;
}

.coming-soon_bottom_TiWP1:after {
  margin-left: -0.5rem !important;
  top: -0.5rem !important;
  transform: rotate(-45deg) !important;
}

.coming-soon_coming-soon-image_OOfGs {
  width: 1.25rem;
  height: 1.25rem;
  vertical-align: middle;
}

[dir='ltr'] .coming-soon_coming-soon-image_OOfGs {
  margin-left: 0.125rem;
}

[dir='rtl'] .coming-soon_coming-soon-image_OOfGs {
  margin-right: 0.125rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/coming-soon/coming-soon.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;EACE,gDAAgD;EAChD,wDAAwD;EACxD,0CAA0C;EAC1C,6DAA6D;EAC7D,gCAAgC;EAChC,sEAAsE;EACtE,0BAA0B;EAC1B,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,4DAA4D;EAC5D,yBAAyB;EACzB,2BAA2B;EAC3B,8DAA8D;EAC9D,+BAA+B;EAC/B,gDAAgD;EAChD,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/*\n * NOTE: the copious use of `important` is needed to overwrite\n * the default tooltip styling, and is required by the 3rd party\n * library being used, `react-tooltip`\n */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.coming-soon {\n  background-color: var(--data-primary) !important;\n  border: 1px solid var(--ui-black-transparent) !important;\n  border-radius: calc(0.5rem / 2) !important;\n  box-shadow: 0 0 0.5rem var(--ui-black-transparent) !important;\n  padding: 0.75rem 1rem !important;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;\n  font-size: 1rem !important;\n  line-height: 1.25rem !important;\n  z-index: 47 !important;\n}\n\n.coming-soon:after {\n  content: '';\n  border-top: 1px solid var(--ui-black-transparent) !important;\n  border-left: 0 !important;\n  border-bottom: 0 !important;\n  border-right: 1px solid var(--ui-black-transparent) !important;\n  border-radius: calc(0.5rem / 2);\n  background-color: var(--data-primary) !important;\n  height: 1rem !important;\n  width: 1rem !important;\n}\n\n.show,\n.show:before,\n.show:after {\n  opacity: 1 !important;\n}\n\n.left:after {\n  margin-top: -0.5rem !important;\n  right: -0.5rem !important;\n  transform: rotate(45deg) !important;\n}\n\n.right:after {\n  margin-top: -0.5rem !important;\n  left: -0.5rem !important;\n  transform: rotate(-135deg) !important;\n}\n\n.top:after {\n  margin-right: -0.5rem !important;\n  bottom: -0.5rem !important;\n  transform: rotate(135deg) !important;\n}\n\n.bottom:after {\n  margin-left: -0.5rem !important;\n  top: -0.5rem !important;\n  transform: rotate(-45deg) !important;\n}\n\n.coming-soon-image {\n  width: 1.25rem;\n  height: 1.25rem;\n  vertical-align: middle;\n}\n\n[dir='ltr'] .coming-soon-image {\n  margin-left: 0.125rem;\n}\n\n[dir='rtl'] .coming-soon-image {\n  margin-right: 0.125rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"coming-soon": `coming-soon_coming-soon_tt9Ea`,
	"comingSoon": `coming-soon_coming-soon_tt9Ea`,
	"show": `coming-soon_show_sVGRX`,
	"left": `coming-soon_left_t3Kyn`,
	"right": `coming-soon_right_nM46w`,
	"top": `coming-soon_top_tnTlL`,
	"bottom": `coming-soon_bottom_TiWP1`,
	"coming-soon-image": `coming-soon_coming-soon-image_OOfGs`,
	"comingSoonImage": `coming-soon_coming-soon-image_OOfGs`
};
export default ___CSS_LOADER_EXPORT___;
